import loadable from '@loadable/component';

const ReactSlick = loadable(() =>
  import(/* webpackChunkName: "ReactSlick" */ './react-slick-module'),
);

export default ReactSlick;
